import styled from '@bd/bdui-styles/emotion';
import { FavoriteUpload } from '../../bdcoreCandidates/Favorites';
// import { colors } from '../../styles';

export default styled(FavoriteUpload)`
`;



// WEBPACK FOOTER //
// ./src/components/Favorites/FavoriteUpload.js